import { render } from "lit-html";
import state from "../state";
import { eventsNav } from "./templates/events-nav";

class EventsNavView {
  constructor() {
    this.dom = document.querySelector("#events-nav");

    render(eventsNav({
      onToggle: ev => this.toggleTimelineMode(ev),
      onResize: action => this.resizeEventsPanel(action)
    }), this.dom);
  }

  resizeEventsPanel(action) {
    state.panelLayout.resizeEvents(action);
    state.channel.publish("onResizePanel");
  }

  toggleTimelineMode(ev) {
    const [_, mode] = ev.target.id.split("-");
    state.channel.publish("onModeSelected", mode);
  }
}

export default EventsNavView;
